// Cliente del workflow n8n `Generar nuevos angulos` (id CVct2q0l0Q5g1HOl),
// alias "carrusel".
//
// QUÉ HACE, que no es obvio por el nombre: NO genera N imágenes de cero. Parte
// de UNA imagen YA GENERADA (`image_id`) y un agente Gemini escribe N prompts
// que mantienen el mismo sujeto y el mismo entorno variando ángulo, pose y
// encuadre. Por eso sirve para "más fotos del mismo mueble en el mismo
// ambiente" y no para "más ideas distintas".
//
// Hasta ahora solo se llamaba desde `GeneratedImagesInline` /
// `GeneratedImagesHistory`, con la imagen que el user tiene abierta. El modo
// Catálogo de muebles lo necesita en lote (una imagen por producto), así que la
// llamada se extrajo acá.

import { GENERATE_AUTH_TOKEN } from '../config';
import type { Medidas } from './medidas';

const NUEVOS_ANGULOS_URL =
  'https://ai-agency-dt7d.onrender.com/webhook/generar_nuevos_angulos';

export interface NuevosAngulosParams {
  userId: string;
  /** Id de la fila de `imagenes_generadas` que se usa como referencia. */
  imageId: string;
  /** Cuántas imágenes NUEVAS pedir (no incluye la original). */
  cantidad: number;
  /**
   * Medidas del producto, para que las tomas alternativas no distorsionen la
   * escala.
   *
   * ⚠️ HOY n8n IGNORA ESTOS CAMPOS: el `<carousel_prompt_generator>` no los
   * lee. Se mandan igual porque son inertes (campos de más en el body) y
   * porque el fix del lado de n8n es justamente inyectarlos en ese prompt —
   * cuando se haga, el front ya los está enviando. Ver ADR-584.
   */
  medidas?: Medidas | null;
  proporcion?: string | null;
}

/**
 * Pide tomas alternativas de una imagen ya generada.
 *
 * Devuelve los ids de `imagenes_generadas` que creó, o `[]` si algo falló. NO
 * tira excepción a propósito: el caller ya tiene las imágenes base en la mano y
 * un fallo acá no debe tumbar toda la generación.
 *
 * ⚠️ TOPE PRÁCTICO: `cantidad` > 2 hace que el workflow loopee hasta su timeout
 * de 180s. Su nodo `get gen images3` tiene `limit: 2` hardcodeado mientras la
 * condición de corte exige `>= cantidad_imagenes`, así que nunca se cumple.
 * Los callers deben limitar a 2 hasta que eso se arregle en n8n.
 */
export async function pedirNuevosAngulos({
  userId,
  imageId,
  cantidad,
  medidas,
  proporcion,
}: NuevosAngulosParams): Promise<string[]> {
  try {
    const res = await fetch(NUEVOS_ANGULOS_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: GENERATE_AUTH_TOKEN,
      },
      body: JSON.stringify({
        user_id: userId,
        image_id: imageId,
        cantidad_imagenes: cantidad,
        ...(medidas ? { medidas } : {}),
        ...(proporcion ? { proporcion } : {}),
      }),
    });
    if (!res.ok) {
      console.warn('[carrusel] respuesta no OK', res.status);
      return [];
    }
    const data = await res.json();
    // El webhook responde a veces como objeto y a veces envuelto en array
    // (mismo doble formato que ya contempla GeneratedImagesInline).
    const ids =
      (Array.isArray(data) ? data[0]?.imagenes_generadas_ids : null) ??
      data?.imagenes_generadas_ids;
    return Array.isArray(ids) ? ids.map((v: unknown) => String(v)) : [];
  } catch (e) {
    console.warn('[carrusel] falló la llamada', e);
    return [];
  }
}
